import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";

import RangePickerItem, {
  getDateFromRangePicker,
} from "../../app/generic/rangePickerItem";
import InputItem from "../../app/generic/inputItem";
import TableFilter from "../../app/generic/tableFilter";
import CheckboxItem from "../../app/generic/checkboxItem";
import FilterSubmit from "../../app/generic/tableFilter/filterSubmit";

const formName = "notification-list";
const dateTimeFrom = moment(moment.now()).add(-6, "months");

function NotificationListFilter({
  form,
  showFilter,
  onSetShowFilter,
  loadNotifications,
}) {
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
    colon: false,
  };
  const intl = useIntl();
  const { getFieldDecorator } = form;

  const [filterState] = useState(
    useSelector((state) => state.filter[formName])
  );
  useEffect(
    () => filterState && onSetShowFilter(true),
    [filterState, onSetShowFilter]
  );

  useEffect(() => {
    loadNotifications && loadNotifications(filterState && filterState.data);
  }, [loadNotifications, filterState]);

  const handleFiltering = useCallback(
    (e, onSetFilterState) => {
      e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            insertionDateTimeFrom: getDateFromRangePicker(
              values.insertionDateTime,
              0
            ),
            insertionDateTimeTo: getDateFromRangePicker(
              values.insertionDateTime,
              1
            ),
            insertionDateTime: undefined,
          };
          loadNotifications(params);
          onSetFilterState(params);
        }
      });
    },
    [form, loadNotifications]
  );

  return (
    <TableFilter showFilter={showFilter}>
      <Form {...formItemLayout}>
        <Row>
          <Col span={12}>
            <InputItem
              label={intl.formatMessage({
                id: "notification.notificationName",
                defaultMessage: "Název notifikace",
              })}
              fieldName="name"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <CheckboxItem
              fieldName="displayToUsers"
              label={intl.formatMessage({
                id: "notification.displayToUsers.filter",
                defaultMessage: "Pouze zobrazené uživatelům",
              })}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
          </Col>
          <Col span={12}>
            <RangePickerItem
              showRanges
              label={intl.formatMessage({
                id: "notification.insertionDateTime",
                defaultMessage: "Datum vytvoření",
              })}
              fieldName="insertionDateTime"
              initialDateFrom={dateTimeFrom}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <FilterSubmit
              form={form}
              formName={formName}
              filterState={filterState}
              onFilterClick={handleFiltering}
            />
          </Col>
        </Row>
      </Form>
    </TableFilter>
  );
}

export default Form.create()(NotificationListFilter);
